import axios from "../api/axios"; // Importing the Axios library for making HTTP requests.

export const getEduvateQuestionAnswer = async (
   email,
  user_type,
  usergptKey,
  doc_id,
  total_words,
  user_tier,
  max_questions_per_chunk,
  user_remaining_quota,
  title,
  text,
  created_at,
  Status,
  no_of_mcq,
  no_of_fib,
  no_of_truefalse,
  no_of_interpritive,
  no_of_descriptive,
  no_of_shqa,
  no_of_sbq,
  sector_name,
  segment_name
) => {
  try {

    // Prepare the request body properly
    let requestBody = {
      doc_id,
      total_words,
      user_tier,
      max_questions_per_chunk,
      user_remaining_quota,
      title,
      text: text,
      created_at,
      Status,
    };

    // If text is a JSON string, parse it and extract the raw content
    if (typeof text === 'string') {
      try {
        const parsedText = JSON.parse(text);
        
        // If it has a 'raw' property, use that instead
        if (parsedText.raw) {
          requestBody.text = parsedText.raw;
        }
      } catch (e) {
        // Text is not JSON, use as-is
        console.log("Text is plain string, using as-is");
      }
    }

    // Sending a POST request to the API endpoint
    const response = await axios.post(
      "/get_question_answer",
      requestBody,
      {
        params: {
          email: email,
          user_type: user_type,
          Usergpt_key: usergptKey,
          no_of_mcq: no_of_mcq,
          no_of_fib: no_of_fib,
          no_of_truefalse: no_of_truefalse,
          no_of_interpritive: no_of_interpritive,
          no_of_descriptive: no_of_descriptive,
          no_of_shqa: no_of_shqa,
          no_of_sbq: no_of_sbq,
          sector_name: sector_name,
          segment_name: segment_name,
        },
        timeout: 300000, // 5 minutes
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      }
    );
    // Returning the response to the caller
    return response;
  } catch (error) {
    // Enhanced error logging
    console.error("Frontend API Error:", {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
    });

    // If an error occurs during the API request, rethrow the error to be handled in the caller component
    throw error;
  }
};